import type {IconName} from '@wandb/components';

import type {RemoteName} from '../shellConfig';

export type HomeProduct = {
  id: string;
  path?: string;
  label: string;
  description: string;
  icon: IconName;
  remote?: RemoteName;
};

export const homeProducts: readonly HomeProduct[] = [
  {
    id: 'aria',
    label: 'ARIA',
    icon: 'lightboard',
    description: 'Coding agent for the AI loop',
  },
  {
    id: 'wandb',
    label: 'Weights & Biases',
    icon: 'model',
    remote: 'wandb',
    description: 'Track ML experiments and evaluate AI applications',
  },
  {
    id: 'post-training',
    label: 'Post-Training',
    icon: 'dumbbell',
    description: 'Distillation, RL and SFT',
  },
  {
    id: 'agentLens',
    path: '/agent-lens',
    label: 'Agent Lens',
    icon: 'aperture',
    remote: 'agentLens',
    description: 'Intelligent agent observability and improvement',
  },
  {
    id: 'inference',
    label: 'Inference',
    icon: 'inference',
    description: 'Leverage the latest models',
  },
  {
    id: 'sandboxes',
    label: 'Sandboxes',
    icon: 'sandbox-playground',
    description: 'On-demand, isolated CPU and GPU compute',
  },
  {
    id: 'notebooks',
    label: 'Notebooks',
    icon: 'notebook',
    description: 'Reactive Python notebooks',
  },
  {
    id: 'registry',
    label: 'Registry',
    icon: 'registries',
    description: 'System of record and controls for assets',
  },
];
